var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadPdf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 24,
    viewBox: "0 0 54 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3505 6.2H32.8505C33.7278 6.2 34.4605 6.494 35.0485 7.082C35.6365 7.67 35.9305 8.40267 35.9305 9.28C35.9305 10.1573 35.6365 10.89 35.0485 11.478C34.4605 12.066 33.7278 12.36 32.8505 12.36H30.3305V16H29.3505V6.2ZM30.3305 11.436H32.8505C33.4571 11.436 33.9565 11.2353 34.3485 10.834C34.7498 10.4327 34.9505 9.91467 34.9505 9.28C34.9505 8.65467 34.7498 8.14133 34.3485 7.74C33.9565 7.32933 33.4571 7.124 32.8505 7.124H30.3305V11.436ZM37.6083 6.2H41.3883C42.7229 6.2 43.8243 6.676 44.6923 7.628C45.5696 8.56133 46.0083 9.71867 46.0083 11.1C46.0083 12.4813 45.5696 13.6433 44.6923 14.586C43.8243 15.5287 42.7229 16 41.3883 16H37.6083V6.2ZM38.5883 15.076H41.3883C42.4616 15.076 43.3389 14.6933 44.0203 13.928C44.7109 13.1533 45.0563 12.2107 45.0563 11.1C45.0563 9.98933 44.7109 9.04667 44.0203 8.272C43.3389 7.50667 42.4616 7.124 41.3883 7.124H38.5883V15.076ZM53.2145 6.2V7.124H48.6645V10.736H53.0045V11.66H48.6645V16H47.6845V6.2H53.2145Z",
    fill: "#122443"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3717_329)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25V3.75",
    stroke: "#122443",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 14.25V19.5C20.25 19.6989 20.171 19.8897 20.0303 20.0303C19.8897 20.171 19.6989 20.25 19.5 20.25H4.5C4.30109 20.25 4.11032 20.171 3.96967 20.0303C3.82902 19.8897 3.75 19.6989 3.75 19.5V14.25",
    stroke: "#122443",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.5L12 14.25L8.25 10.5",
    stroke: "#122443",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3717_329"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPdf);
export default __webpack_public_path__ + "static/media/download-pdf.c7b055a8346000f94a8a2d62fd83f749.svg";
export { ForwardRef as ReactComponent };